module.exports = __webpack_public_path__ + "static/media/thumbnail.a3a4f048.jpg";